module.exports = __webpack_public_path__ + "img/Image_18.65808f59.png";